import {commonActions} from '../../actions/commonActions';
import {warehouseSetList,warehouseGetItem} from '../../actions/WarehouseActions';
import {connect} from 'react-redux';
import List from '../../components/warehouse/WarehouseInventoryList';
import {API_FETCH} from '../../services/FetchService';
import {list as productList} from "../../containers/product/ProductListPage";
import {getItem as userInfo} from '../../containers/user/AddEditFormPage';

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.warehouse.list,
        common       : state.common,
        initialValues: state.warehouse.getItem,
        productList  : state.product.list,
        userList     : state.user.list,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    getProductList: (value) => {
        dispatch(productList(value));
    },
    getUserInfo: (id) => {
        return(dispatch(userInfo(id)))
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

const list = (value) => {
    return (dispatch, getState) => {
        let states = getState()
        let url;

        if(states.router.location && states.router.location.pathname) {
            url = states.router.location.pathname.split('/')
            let key = url['3']
            switch (url[2]) {
                case 'product':
                    value.product = key
                    break;
                case 'state':
                    value.state = key
                    value.warehouse_type='state'
                    break;
                case 'order':
                    value.order = key
                    break;
                case 'technician':
                    value.technician = key
                    value.warehouse_type='technician'
                    break;
            }

        }

        if(value) {
            if(value.created_from && value.created_from._d)
                value.created_from = value.created_from._d.toISOString()
            if(value.created_to && value.created_to._d)
                value.created_to = value.created_to._d.toISOString()
        }

        API_FETCH.get('warehouse/v2/warehouse',{params: value}).then(list => {
            dispatch(warehouseSetList(list.data.result));
            // dispatch(warehouseGetItem(list.data.result.lists[0]));
        }).catch(error => {
            console.log(error);
        });
    }

}


export default connect(mapStateToProps, mapDispatchToProps)(List);
